<template>
  <LegacyPageContent v-if="hasProfile">
    <v-row
      no-gutters
      align="center"
      class="mb-2"
    >
      <v-col>
        <div class="headline">
          Rewards
          <InfoIcon @onClick="handleInfoIconClick" />
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <MoreInfo />

      <!-- <v-tabs grow v-model="tabs" class="mb-3">
        <v-tab href="#summary" class="ml-0">
          Summary
        </v-tab>

        <v-tab href="#more">
          More Info
        </v-tab>
      </v-tabs>
    </v-row>

    <v-row no-gutters>
      <v-col>
        <v-tabs-items v-model="tabs">
          <v-tab-item value="summary">
            <Summary />
          </v-tab-item>

          <v-tab-item value="more">
            <MoreInfo />
          </v-tab-item>
        </v-tabs-items>
      </v-col> -->
    </v-row>
    <InfoDialog
      title="Earn financial rewards easily"
      :show.sync="showInfoDialog"
    >
      <div>
        <ol>
          <li>Refer one of your contacts to earn 1000 euros</li>
          <li>Post a job opportunity and partner with Riverflex to earn 40% margin share</li>
        </ol>
      </div>
    </InfoDialog>
  </LegacyPageContent>
</template>
<script lang="ts">
import { mapGetters } from 'vuex'
import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'

// import Summary from '@/components/rewards/Summary.vue'
import MoreInfo from '@/components/rewards/MoreInfo.vue'
import InfoDialog from '@/components/core/InfoDialog.vue'
import InfoIcon from '@/components/core/InfoIcon.vue'
import ShowInfoDialogMixin, { IShowDialogMixin } from '@/mixins/ShowInfoDialog.mixin'
import { trackHelpBtnTap } from '@/segmentAnalytics/common'
import LegacyPageContent from '@/components/layouts/LegacyPageContent.vue'

@Component({
  components: {
    // Summary,
    MoreInfo,
    InfoDialog,
    InfoIcon,
    LegacyPageContent
  },
})
export default class Rewards extends Mixins(ShowInfoDialogMixin) implements IShowDialogMixin {
  @Prop() hasProfile: boolean

  // data
  pageName: string = 'rewards'
  tabs: null|string = null
  showInfoDialog: boolean = false

  // lifecycle hooks
  mounted () {
    this.tabs = this.$route.hash.replace('#', '')
  }

  handleInfoIconClick () {
    trackHelpBtnTap('rewards')
    this.showInfoDialog = true
  }
}
</script>
